import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitopunecab() {



const cardData = {
  keyword: "Mumbai to Pune Cab",

headingDescription:
  "Omshree Cab offers safe and comfortable Mumbai to Pune cab services for travelers seeking a hassle-free journey between two of Maharashtra’s most prominent cities. Whether you are planning a business trip, a weekend getaway, a family visit, or a group tour, our cab service ensures reliable travel with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Pune cab services.",

topPlaces: [
  {
    title: "Shaniwar Wada",
    description:
      "Shaniwar Wada is a historic fortification in Pune, known for its rich Maratha history and architectural grandeur. Built in the 18th century, it was the seat of the Peshwas and features impressive gates, gardens, and courtyards. Visitors can explore the fort, learn about Maratha heritage, and witness sound-and-light shows in the evenings. Traveling by cab ensures a comfortable and timely arrival, allowing tourists to enjoy the site at their own pace without worrying about parking or local transport."
  },
  {
    title: "Aga Khan Palace",
    description:
      "Aga Khan Palace is a majestic landmark in Pune, known for its historical and cultural significance. It served as a prison for Mahatma Gandhi and other freedom fighters during India’s independence movement. Visitors can admire the architecture, explore the museum dedicated to Gandhi, and stroll through the well-maintained gardens. A cab ride allows travelers to reach the palace conveniently, spend ample time exploring the grounds, and combine the visit with other nearby attractions without transport hassles."
  },
  {
    title: "Sinhagad Fort",
    description:
      "Sinhagad Fort is a hill fortress near Pune, popular among trekkers, history enthusiasts, and nature lovers. The fort offers panoramic views of the Sahyadri mountains, historic gates, and ancient watchtowers. Visitors can enjoy trekking, photography, and local snacks sold near the summit. Traveling by cab ensures easy access to the base of the fort, allows flexible timing for the trek, and provides a comfortable return journey after a day of exploration."
  },
  {
    title: "Pataleshwar Cave Temple",
    description:
      "Pataleshwar Cave Temple is an ancient rock-cut temple in Pune dedicated to Lord Shiva, dating back to the 8th century. The temple features intricate carvings, a serene courtyard, and a peaceful atmosphere for worshippers and tourists alike. A cab ride allows visitors to reach the temple conveniently, explore the surroundings, and plan their visit along with other Pune landmarks without the stress of public transport."
  },
  {
    title: "Osho Ashram",
    description:
      "Osho Ashram in Pune is a center for meditation and spiritual learning, attracting visitors from across India and abroad. The ashram offers meditation programs, workshops, and serene gardens for reflection. Traveling by cab ensures a comfortable and timely visit, allowing guests to experience the ashram fully while combining it with sightseeing at other Pune attractions."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description:
      "Raja Dinkar Kelkar Museum is home to an extensive collection of Indian artifacts, including sculptures, musical instruments, textiles, and everyday items. The museum offers a glimpse into India’s rich cultural heritage and artistry. A cab ride allows travelers to reach the museum conveniently, spend adequate time exploring the exhibits, and plan visits to nearby historic sites and markets without transport concerns."
  },
  {
    title: "Parvati Hill and Temple",
    description:
      "Parvati Hill is a historic site in Pune featuring a hilltop temple dedicated to Parvati and offering panoramic views of the city. Visitors can climb the steps to the temple, enjoy the gardens, and explore the museum at the base. Traveling by cab ensures a comfortable journey, flexibility in timing, and easy access for families or senior travelers wishing to enjoy both spiritual and scenic experiences."
  },
  {
    title: "Koregaon Park",
    description:
      "Koregaon Park is a trendy area in Pune known for its cafes, boutiques, and lively atmosphere. Visitors can enjoy shopping, dining, and leisurely strolls along tree-lined streets. A cab service allows travelers to explore this popular neighborhood conveniently, hop between eateries, and plan their day efficiently without worrying about parking or navigating local traffic."
  },
  {
    title: "Bund Garden",
    description:
      "Bund Garden is a beautiful urban park in Pune located along the Mula-Mutha river, offering walking paths, gardens, and recreational spaces. It is ideal for relaxation, photography, and spending quality time with family. Traveling by cab ensures hassle-free access, making it easy for visitors to combine a visit to Bund Garden with other nearby attractions like Shaniwar Wada or Pataleshwar Temple."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description:
      "Pune Okayama Friendship Garden, also known as the Pu La Deshpande Garden, is a Japanese-style garden in Pune featuring landscaped lawns, ponds, and traditional Japanese architecture. Visitors can enjoy a peaceful environment, photography, and a scenic retreat from the bustling city. A cab ride allows travelers to explore this serene garden comfortably and include it as part of a broader Pune sightseeing itinerary."
  }
],

services: [
{
name: "Mumbai to Pune Cab",
description: "Mumbai to Pune cab service offers comfortable and reliable intercity travel between the two major cities of Maharashtra. Our AC sedans, SUVs, and premium vehicles ensure a smooth journey via the Mumbai–Pune Expressway. Professional drivers provide safe and efficient highway driving. Pickup is available from homes, hotels, offices, and Mumbai airport. Ideal for business travel, family trips, and airport transfers."
},
{
name: "Mumbai to Pune Taxi",
description: "Mumbai to Pune taxi service provides convenient road transportation for travelers commuting between the two cities. Comfortable AC vehicles ensure relaxed highway journeys. Experienced drivers ensure safe and timely travel. Flexible pickup options are available across Mumbai. Perfect for corporate travel, family visits, and weekend trips."
},
{
name: "Mumbai to Pune Cab Service",
description: "Mumbai to Pune cab service is designed for passengers seeking reliable and comfortable intercity travel. Well-maintained vehicles and professional drivers ensure smooth highway journeys. Pickup is available from any location in Mumbai including airport terminals. AC interiors make long-distance travel relaxing."
},
{
name: "Mumbai to Pune Taxi Service",
description: "Mumbai to Pune taxi service offers dependable transportation for daily travelers, tourists, and corporate clients. Comfortable AC vehicles ensure relaxed seating during the trip. Professional drivers ensure safe driving along the expressway. Flexible booking options make travel planning easy."
},
{
name: "Cab from Mumbai to Pune",
description: "Cab from Mumbai to Pune provides a convenient private travel option for passengers planning road trips between the cities. Comfortable vehicles ensure smooth highway journeys. Experienced drivers ensure safe and timely arrival. Ideal for corporate travel, airport transfers, and family trips."
},
{
name: "Taxi from Mumbai to Pune",
description: "Taxi from Mumbai to Pune offers reliable transportation with comfortable vehicles and experienced drivers. The service is ideal for business travelers, tourists, and families. Flexible pickup locations across Mumbai ensure convenient travel planning."
},
{
name: "Mumbai to Pune Cab Booking",
description: "Mumbai to Pune cab booking allows passengers to reserve vehicles quickly for comfortable intercity travel. Instant booking confirmation and flexible pickup options simplify trip planning. Sedan, SUV, and premium vehicles are available for different travel needs."
},
{
name: "Mumbai to Pune Taxi Booking Online",
description: "Online taxi booking from Mumbai to Pune allows travelers to reserve vehicles instantly from anywhere. Quick confirmation and easy scheduling simplify travel planning. AC vehicles and trained drivers ensure comfortable highway journeys."
},
{
name: "Mumbai to Pune Cab Price",
description: "Mumbai to Pune cab price offers competitive and transparent fare options for travelers. Customers can select sedan, SUV, or luxury vehicles depending on budget and comfort needs. Clear pricing ensures no hidden charges."
},
{
name: "Mumbai to Pune Taxi Fare",
description: "Mumbai to Pune taxi fare is calculated with transparent per-km pricing and simple billing. Travelers receive affordable travel options with clear fare structure. Comfortable vehicles ensure relaxed intercity travel."
},
{
name: "Mumbai to Pune One Way Cab",
description: "One way cab from Mumbai to Pune is ideal for travelers who only require drop service without paying return charges. This option helps reduce travel costs significantly. AC vehicles ensure comfortable expressway travel."
},
{
name: "Mumbai to Pune Round Trip Taxi",
description: "Round trip taxi from Mumbai to Pune offers convenient return travel for passengers planning short visits or meetings. Flexible return scheduling allows travelers to plan trips comfortably."
},
{
name: "Mumbai Airport to Pune Cab",
description: "Mumbai airport to Pune cab service provides direct transportation for travelers arriving at Mumbai airport. Immediate pickup ensures quick travel to Pune via expressway. Comfortable AC vehicles and experienced drivers ensure safe travel."
},
{
name: "Mumbai to Pune Innova Cab",
description: "Innova cab from Mumbai to Pune is ideal for families and groups needing spacious seating and luggage capacity. The premium MPV provides comfortable travel for long-distance journeys."
},
{
name: "Mumbai to Pune Ertiga Cab",
description: "Ertiga cab from Mumbai to Pune offers comfortable travel for medium-size families and small groups. Spacious interiors ensure relaxed seating throughout the journey."
},
{
name: "Mumbai to Pune Sedan Cab",
description: "Sedan cab from Mumbai to Pune provides economical travel for couples and small families. Vehicles like Swift Dzire and Etios ensure smooth and comfortable highway journeys."
},
{
name: "Mumbai Pune Cab Service",
description: "Mumbai Pune cab service provides reliable daily transportation between the two cities. Comfortable vehicles and professional drivers ensure smooth expressway travel. Ideal for business commuters and airport transfers."
}
],

tableData: [
["Mumbai to Pune Cab","Mumbai to Pune Taxi"],
["Mumbai to Pune Cab Service","Mumbai to Pune Taxi Service"],
["Cab from Mumbai to Pune","Taxi from Mumbai to Pune"],
["Mumbai to Pune Cab Booking","Mumbai to Pune Taxi Booking Online"],
["Mumbai to Pune Cab Price","Mumbai to Pune Taxi Fare"],
["Mumbai to Pune One Way Cab","Mumbai to Pune Round Trip Taxi"],
["Mumbai Airport to Pune Cab","Mumbai to Pune Innova Cab"],
["Mumbai to Pune Ertiga Cab","Mumbai to Pune Sedan Cab"],
["Mumbai Pune Cab Service","Best Cab Mumbai to Pune"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in handling the Mumbai–Pune Expressway and old highway routes. They understand traffic conditions, toll plazas, and alternate routes, ensuring a fast, safe, and smooth journey between Mumbai and Pune."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs follows a transparent pricing policy for Mumbai to Pune cab bookings. We clearly explain the per-kilometer fare, toll charges, and trip packages before confirmation so customers never face hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you need an early morning airport drop, a late-night return trip, or a same-day business travel between Mumbai and Pune, Omshree Cabs provides round-the-clock cab availability and booking support."
  },
  {
    WhyChooseheading: "Clean AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well-maintained, fully air-conditioned, and thoroughly cleaned before every trip. Our focus on hygiene and comfort ensures a relaxing journey even during frequent Mumbai–Pune travel."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We offer flexible trip options including one-way cabs, round trips, and same-day return packages between Mumbai and Pune. Travelers can choose the option that best fits their schedule and travel requirements."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium cars. Whether you are traveling alone, with family, or with colleagues, we provide the right vehicle for your journey."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai. Our drivers arrive on time so your journey to Pune begins smoothly without any travel hassle."
  },
  {
    WhyChooseheading: "Reliable Daily Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for daily Mumbai to Pune cab services. With punctual drivers, comfortable vehicles, and reliable support, we ensure you reach Pune safely and on time."
  }
]
};


const faqData = [
  { question: "What is the distance from Mumbai to Pune by cab?", answer: "The distance between Mumbai and Pune is approximately 150 km and usually takes around 3–4 hours via the Mumbai–Pune Expressway." },
  { question: "Do you provide one-way Mumbai to Pune cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Pune." },
  { question: "Which vehicles are available for Mumbai to Pune travel?", answer: "We provide sedans, SUVs like Ertiga and Innova, and premium vehicles depending on your comfort and group size." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we offer direct pickup from Mumbai Airport for Pune travel." },
  { question: "Do you provide daily Mumbai to Pune cab services?", answer: "Yes, many customers book our daily cab service for business or regular travel between Mumbai and Pune." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, every vehicle provided by Omshree Cabs is fully air-conditioned for a comfortable journey." },
  { question: "Can I book a same-day return trip?", answer: "Yes, same-day return packages are available for Mumbai to Pune travel." },
  { question: "Can we stop during the journey for food or breaks?", answer: "Yes, passengers can request stops during the trip for meals, rest, or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and peak travel hours." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Shah",
    feedback:
      "I frequently travel from Mumbai to Pune for business and Omshree Cabs has always been reliable. Clean car, professional driver, and very comfortable ride on the expressway.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Booked Omshree Cabs for our family trip from Mumbai to Pune. On-time pickup, smooth journey, and transparent pricing. Excellent cab service.",
    rating: 5
  }
];


























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Cab",
  "description": "Book Mumbai to Pune Cab with Omshree Cab for safe and comfortable travel. Choose from Innova, Ertiga, and Sedan taxis for one-way or round trips, including Mumbai Airport to Pune transfers. Affordable fares, easy online cab booking, and reliable Mumbai Pune cab service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4500"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Mumbai to Pune Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune Cab with Omshree Cab for safe and comfortable travel. Choose from Innova, Ertiga, and Sedan taxis for one-way or round trips, including Mumbai Airport to Pune transfers. Affordable fares, easy online cab booking, and reliable Mumbai Pune cab service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/7.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopunecab;